import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../components/SideNav.css";
import logoImage from "../assets/logo.png";
import { hasPermission } from "../utils/permissions";

export default function SideNav() {
    const [canSeeMasters, setCanSeeMasters] = useState(false);
    const [canSeeOrders, setCanSeeOrders] = useState(false);
    const [canSeeLeads, setCanSeeLeads] = useState(false);

    const [canCreatePatient, setCanCreatePatient] = useState(false);
    const [canSeeCourierEntry, setCanSeeCourierEntry] = useState(false);
    const [canSeeCourierList, setCanSeeCourierList] = useState(true);
    const [canSeePatientNotepad, setCanSeePatientNotepad] = useState(false);
    const handleLinkClick = () => {
        // Close sidebar on mobile after clicking any link
        if (sidebarOpen) setSidebarOpen(false);
    };

    useEffect(() => {
        const checkPermission = async () => {
            setCanSeeMasters(!!(await hasPermission("folders", "masterview")));
            setCanSeeOrders(!!(await hasPermission("folders", "ordersview")));
            setCanSeeLeads(!!(await hasPermission("folders", "leadview")));

            setCanCreatePatient(
                !!(await hasPermission("operation", "addpatiententry"))
            );

            // ✅ FIXED LINE
            setCanSeePatientNotepad(
                !!(await hasPermission("folders", "notepadview"))
            );

            setCanSeeCourierEntry(
                !!(await hasPermission("delivery", "adddelivery"))
            );
            setCanSeeCourierList(
                !!(await hasPermission("delivery", "viewdelivery"))
            );
        };


        checkPermission();

        const handlePermissionUpdate = () => checkPermission();
        window.addEventListener("permissionsUpdated", handlePermissionUpdate);

        return () =>
            window.removeEventListener(
                "permissionsUpdated",
                handlePermissionUpdate
            );
    }, []);

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [mastersOpen, setMastersOpen] = useState(false);
    const [patientsOpen, setPatientsOpen] = useState(false);
    const [ordersOpen, setOrdersOpen] = useState(false);
    const [couriersOpen, setCouriersOpen] = useState(false);
    const [leadsOpen, setLeadsOpen] = useState(false);

    return (
        <>
            <div className="mobile-toggle">
                <button onClick={() => setSidebarOpen(!sidebarOpen)}>
                    {sidebarOpen ? "✖" : "☰"}
                </button>
            </div>

            <div className={`sidenav ${sidebarOpen ? "open" : ""}`}>
                <div className="sidenav-header shadow-sm border-bottom">
                    <a href="/dashboard">
                        <img src={logoImage} alt="Logo" className="logo" />
                    </a>
                </div>

                <div className="sidenav-menu">
                    <Link to="/DashBoard" onClick={handleLinkClick}>📊 Dashboard</Link>

                    {/* ✅ MASTERS */}
                    {canSeeMasters && (
                        <div className="dropdown">
                            <div
                                className="dropdown-header"
                                onClick={() => setMastersOpen(!mastersOpen)}
                            >
                                <span>🗂️ Masters</span>
                                <span>{mastersOpen ? "▲" : "▼"}</span>
                            </div>

                            {mastersOpen && (
                                <div className="dropdown-content">
                                    <Link to="/profile" onClick={handleLinkClick}>👤 Profile</Link>
                                    <Link to="/Branch" onClick={handleLinkClick}>🏠 Branch</Link>
                                    <Link to="/user" onClick={handleLinkClick}>🧑 User</Link>
                                    <Link to="/Product" onClick={handleLinkClick}>🛒 Product</Link>
                                    <Link to="/Category" onClick={handleLinkClick}>📂 Category</Link>
                                    <Link to="/Diagnoses" onClick={handleLinkClick}>🧬 Diagnose</Link>
                                    <Link to="/Staff" onClick={handleLinkClick}>
                                        💰 Staff Incentive
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}

                    {/* PATIENT ENTRY */}
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setPatientsOpen(!patientsOpen)}
                        >
                            <span>🧑‍🤝‍🧑 Patient Entry</span>
                            <span>{patientsOpen ? "▲" : "▼"}</span>
                        </div>

                        {patientsOpen && (
                            <div className="dropdown-content">
                                {canCreatePatient && (
                                    <Link to="/NewEntry" onClick={handleLinkClick}>📝 New Entry</Link>
                                )}
                                <Link to="/PatientList" onClick={handleLinkClick}>📋 Patient List</Link>
                                {canSeePatientNotepad && (
                                    <Link to="/PatientNotepad" onClick={handleLinkClick}>🗒️ Patient Notepad</Link>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ✅ ORDERS – SAME AS MASTERS */}
                    {canSeeOrders && (
                        <div className="dropdown">
                            <div
                                className="dropdown-header"
                                onClick={() => setOrdersOpen(!ordersOpen)}
                            >
                                <span>📦 Orders</span>
                                <span>{ordersOpen ? "▲" : "▼"}</span>
                            </div>

                            {ordersOpen && (
                                <div className="dropdown-content">
                                    <Link to="/WetaOrderList" onClick={handleLinkClick}>
                                        🧾 Weta Order List
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}

                    {/* COURIER */}
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setCouriersOpen(!couriersOpen)}
                        >
                            <span>🚚 Courier</span>
                            <span>{couriersOpen ? "▲" : "▼"}</span>
                        </div>

                        {couriersOpen && (
                            <div className="dropdown-content">
                                {canSeeCourierEntry && (
                                    <Link to="/CourierEntry" onClick={handleLinkClick}>
                                        📝 Courier Entry
                                    </Link>
                                )}
                                {canSeeCourierList && (
                                    <Link to="/CourierEntryList" onClick={handleLinkClick}>
                                        🧾 Courier List
                                    </Link>
                                )}
                                {canSeeCourierList && (
                                    <Link to="/CourierIntegration" onClick={handleLinkClick}>
                                        📝 Courier Integration
                                    </Link>
                                )}

                                 {canSeeLeads && (
                        <Link to="https://leadurl.awasthivitality.com/pincode-serviceability.php" target="_blank">📍 Pincode Serviceability </Link>
                    )}
                            </div>
                        )}
                    </div>

                    {/* ✅ LEAD MANAGEMENT – SAME AS MASTERS */}
                    {/* LEAD MANAGEMENT */}
{canSeeLeads && (
    <div className="dropdown">
        <div
            className="dropdown-header"
            onClick={() => setLeadsOpen(!leadsOpen)}
        >
            <span>👤 Lead </span>
            <span>{leadsOpen ? "▲" : "▼"}</span>
        </div>

        {leadsOpen && (
            <div className="dropdown-content">

                <Link
                    to="/LeadManagement"
                    onClick={handleLinkClick}
                >
                    👤 Lead List
                </Link>

                <Link
                    to="http://leadurl.awasthivitality.com/lead-report.php"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    📊 Lead Report
                </Link>

            </div>
        )}
    </div>
)}

                   

                    {canSeeLeads && (
    <Link
        to="http://13.202.42.222/momshostel/login"
        target="_blank"
        rel="noopener noreferrer"
    >
        <img
            src="http://13.202.42.222/momshostel/assets/images/logo.png"
            alt="Hostel CRM"
            style={{
                width: "20px",
                height: "20px",
                marginRight: "8px",
                verticalAlign: "middle"
            }}
        />
        Hostel CRM
    </Link>
)}

                </div>
            </div>
        </>
    );
}
